module.exports = __webpack_public_path__ + "static/media/documents_icon.9f08868a.svg";